import OrganizationsArchive from './OrganizationsArchive'

export default OrganizationsArchive
